import { observer } from "mobx-react-lite";
import MainLayout, { MAIN_RIGHT_TOP_HEIGHT } from "../MainLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { VerticalLayout } from "../../common/common-layout";
import { TitleLargeMedium, TitleMediumBold } from "../../common/common-text";
import { useEffect, useState } from "react";
import BTBox from "../../common/components/BTBox";
import { BTDateComponent } from "../../common/components/BTDateComponent";
import { BTCheckBox } from "../../common/components/BTCheckBox";
import BTReader from "../../common/components/board/BTReader";
import { dialogStore } from "../../store/DialogStore";
import {
    requestDeleteAllFiles,
    requestDeleteNoticeDocuments,
} from "../../service/BoardService";
import Divider from "@mui/material/Divider";
import theme from "../../common/theme";
import { formatDateToYMD } from "../../common/utils/DateUtils";

const NoticeBoardDetail = () => {
    return (
        <MainLayout>
            <NoticeBoardDetailBody />
        </MainLayout>
    );
};

export default NoticeBoardDetail;

const NoticeBoardDetailBody = observer(() => {
    const location = useLocation();
    const navigate = useNavigate();
    const [notice, setNotice] = useState<any>(null);

    useEffect(() => {
        const stateNotice = location.state?.notice;
        if (stateNotice) {
            setNotice(stateNotice);
        }
    }, [location.state]);

    const handleEdit = () => {
        if (!notice) return;
        navigate("/board/notice/edit", { state: { notice } });
    };

    const handleDelete = async () => {
        if (!notice) return;

        const deleteConfirmed = await dialogStore.showAsyncDialog({
            title: "경고",
            message: "현재 공지사항을 정말로 삭제하시겠습니까?",
            isCaution: true,
        });

        if (!deleteConfirmed) return;

        try {
            await requestDeleteNoticeDocuments([notice.id!]);
            await requestDeleteAllFiles("notice", notice.id!);

            dialogStore.showDialog({
                title: "삭제 완료",
                message: "공지사항이 삭제되었습니다.",
                onConfirm: () => navigate(-1),
                onClose: () => navigate(-1),
            });
        } catch (e) {
            console.error("공지사항 삭제 실패", e);
            dialogStore.showDialog({
                title: "오류",
                message: "공지사항 삭제 중 오류가 발생했습니다.",
                onConfirm: () => {},
                onClose: () => {},
            });
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    if (!notice) return null;

    return (
        <VerticalLayout height={"auto"} paddingLeft={36} paddingRight={36}>
            <TitleLargeMedium>공지사항 상세</TitleLargeMedium>
            <BTBox height="24px" />
            <Divider
                style={{
                    width: "100%",
                    backgroundColor: '#D9D9D9',
                }}
            />

            <VerticalLayout height={"auto"} paddingBottom={36}>
                <TitleMediumBold style={{ marginTop: "20px" }}>
                    공지사항 정보
                </TitleMediumBold>
                <BTBox height="16px" />
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        flexWrap: "nowrap",
                        fontSize: "14px",
                        color: "#6C757D",
                    }}
                >
                    <b style={{ whiteSpace: "nowrap" }}>게시일자</b>
                    <div style={{ width: 220, flex: "0 0 auto" }}>
                        <div>{formatDateToYMD(notice.postDate)}</div>
                    </div>

                    <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ borderColor: "#6C757D", mx: "4px" }}
                    />

                    <b style={{ whiteSpace: "nowrap" }}>상단 고정 여부</b>
                    <div>{notice.isAnchored ? "✅" : "❌"}</div>

                    <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ borderColor: "#6C757D", mx: "4px" }}
                    />

                    <b style={{ whiteSpace: "nowrap" }}>글 공개 여부</b>
                    <div>{notice.isPublished ? "✅" : "❌"}</div>
                </div>

                <BTBox height="16px" />
                <Divider
                    style={{
                        width: "100%",
                        backgroundColor: '#D9D9D9',
                    }}
                />
                <TitleMediumBold style={{ marginTop: "20px" }}>
                    공지사항 컨텐츠 정보
                </TitleMediumBold>
                <BTBox height="16px" />

                {/* 여기서부터 폭 100% 확보 */}
                <div style={{ width: "100%" }}>
                    <BTReader
                        title={notice.title}
                        contents={notice.contents}
                        attachedFiles={notice.attachedFiles || []}
                        createdBy={notice.createdBy}
                        createdAt={notice.createdAt?.toLocaleString()}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        onBack={handleBack}
                    />
                </div>
            </VerticalLayout>
        </VerticalLayout>
    );
});